import { LocationsState } from './types';
import * as constants from './constants';
import { createDateRange, replaceUmlauts } from '@repo/apg-ui';

/* eslint-disable no-alert, @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unsafe-assignment */
const initialState: LocationsState = {
  searchLocations: {},
  searchParameters: {
    startDate: new Date(),
    sort: { name: 0, price: 0 },
    isShowUnavailable: true,
    currentSort: 'price',
    duration: 7,
    dateRanges: [
      createDateRange(new Date(), 7, {
        toEndOfYear: false,
        fullWeeks: false,
      }),
    ],
    timeslot: 1,
    timeslotInfo: null,
    industries: [],
    isBudgetSelected: true,
    budget: 0,
    isFrequencySelected: false,
    frequency: 0,
    spotLength: 0,
  },
};

export const locationsReducer = (state: LocationsState = initialState, action: any) => {
  switch (action.type) {
    case constants.SET_LOCATIONS:
      return {
        ...state,
        searchLocations: action.payload,
      };
    case constants.SET_SEARCH_PARAMS:
      return {
        ...state,
        searchParameters: {
          ...state.searchParameters,
          ...action.payload,
        },
      };
    case constants.ADD_LOCATION: {
      let newLocation = { ...action.payload };
      let isLocality;
      let isSublocality;

      const radius = newLocation.radius ? newLocation.radius : 1000;
      const radiusUnit = newLocation.radiusUnit ? newLocation.radiusUnit : 'm';

      if (newLocation.types) {
        const types = typeof newLocation.types === 'string' ? newLocation.types : (newLocation.types || []).join('-');
        isLocality = types.includes('locality');
        isSublocality = types.includes('sublocality');
      }

      if (isLocality || isSublocality) {
        newLocation['circle'] = {
          radius: isSublocality ? radius : isLocality ? null : radius,
          radiusUnit: isSublocality ? radiusUnit : isLocality ? null : radiusUnit,
        };
      } else {
        newLocation['circle'] = {
          radius: newLocation.radius,
          radiusUnit: newLocation.radiusUnit,
        };
      }

      newLocation['urn'] =
        `${newLocation.context}:${newLocation.address}:${newLocation.lngLtd?.lng}:${newLocation.lngLtd?.lat}`;

      let newLocations = {
        ...state.searchLocations,
        [replaceUmlauts(newLocation.address)]: newLocation,
      };

      return {
        ...state,
        searchLocations: newLocations,
        mapCenter: action.payload.lngLtd,
      };
    }

    case constants.UPDATE_LOCATION: {
      let payload = { ...action.payload };

      let locations = { ...state.searchLocations };
      let location = locations[replaceUmlauts(payload.address)];
      location['circle'] = {
        radius: payload.radius,
        radiusUnit: payload.radiusUnit,
      };
      locations[replaceUmlauts(payload.address)] = location;

      return {
        ...state,
        searchLocations: locations,
        mapCenter: location.lngLtd,
      };
    }

    case constants.REMOVE_LOCATION: {
      let newLocations = { ...state.searchLocations };
      newLocations[action.payload] && delete newLocations[action.payload];

      return {
        ...state,
        searchLocations: newLocations,
      };
    }

    case constants.RESET_ALL: {
      return {
        ...state,
        searchLocations: {},
        searchParameters: {
          ...state.searchParameters,
          startDate: new Date(),
          sort: { name: 0, price: 0 },
          isShowUnavailable: true,
          currentSort: 'price',
          duration: 7,
          dateRanges: [
            createDateRange(new Date(), 7, {
              toEndOfYear: false,
              fullWeeks: false,
            }),
          ],
          timeslot: 1,
          timeslotInfo: null,
          industries: [],
          isBudgetSelected: false,
          budget: 0,
          isFrequencySelected: false,
          frequency: 0,
          spotLength: 0,
        },
      };
    }

    case constants.UPDATE_AVAILABILITY: {
      return {
        ...state,
        searchParameters: {
          ...state.searchParameters,
          isShowUnavailable: action.payload,
        },
      };
    }
    default:
      return state;
  }
};
